import { createSlice } from "@reduxjs/toolkit";
import uuidv4 from "uuid/v4";

const initialState = {
    "id" : uuidv4(),
    "connStatus": ""
}
const connectionStatusSlice = createSlice({
    name:'connectionStatusSlice',
    initialState,
    reducers:{
        updateconnStatus: (_state,payload)=>{
               return {
                "id" : uuidv4(),
                "connStatus": payload.payload
               }
        }
    }
});

export default connectionStatusSlice.reducer
export const updateconnStatus = connectionStatusSlice.actions.updateconnStatus